function toAmount(value) {
    const parsed = typeof value === 'number' ? value : Number(value);
    return Number.isFinite(parsed) ? parsed : 0;
}
function isPeriodicReleasePool(resetPolicy) {
    return resetPolicy?.type === 'periodic_release';
}
function usagePercent(granted, used) {
    if (granted <= 0) {
        return 0;
    }
    return Math.round((used / granted) * 100);
}
function usageSegmentPercentOfGranted(granted, usageTotal) {
    if (granted <= 0) {
        return 0;
    }
    const spend = usageTotal > 0 ? usageTotal : 0;
    return Math.min(100, Math.round((spend / granted) * 100));
}
function buildUsageMetrics(granted, usageCommitted, usagePending, usageScope) {
    const used = Math.max(usageCommitted + usagePending, 0);
    return {
        used,
        granted,
        usageCommitted,
        usagePending,
        usagePercent: usagePercent(granted, used),
        committedUsagePercent: usageSegmentPercentOfGranted(granted, usageCommitted),
        pendingUsagePercent: usageSegmentPercentOfGranted(granted, usagePending),
        usageScope,
    };
}
/** Usage numerators/denominators for admin and customer UI. Periodic-release pools use the current period only. */
export function resolveSowPoolUsageDisplayMetrics(input) {
    const granted = toAmount(input.granted);
    const usageCommitted = toAmount(input.usageCommitted);
    const usagePending = toAmount(input.usagePending);
    if (!isPeriodicReleasePool(input.resetPolicy)) {
        return buildUsageMetrics(granted, usageCommitted, usagePending, 'lifetime');
    }
    const currentPeriod = (input.periodSummaries ?? []).find((period) => period.isCurrent);
    if (!currentPeriod) {
        return buildUsageMetrics(granted, usageCommitted, usagePending, 'lifetime');
    }
    const periodCommitted = toAmount(currentPeriod.usageCommitted);
    const periodPending = toAmount(currentPeriod.usagePending);
    const releaseAmount = toAmount(currentPeriod.releaseAmount);
    const previousPeriod = (input.periodSummaries ?? []).find((period) => period.index === currentPeriod.index - 1);
    const carryIn = previousPeriod ? toAmount(previousPeriod.carriedIntoNext ?? 0) : 0;
    const periodGranted = releaseAmount + carryIn;
    return buildUsageMetrics(periodGranted, periodCommitted, periodPending, 'current_period');
}
export function poolUsageReflectsCurrentPeriod(input) {
    if (!isPeriodicReleasePool(input.resetPolicy)) {
        return false;
    }
    return (input.periodSummaries ?? []).some((period) => period.isCurrent);
}
export function periodicReleaseCurrentPeriodLabel(cadence) {
    switch (cadence) {
        case 'monthly':
            return 'Current month';
        case 'quarterly':
            return 'Current quarter';
        case 'yearly':
            return 'Current year';
        default:
            return null;
    }
}
//# sourceMappingURL=sow-pool-usage-display.js.map